<div class="container">
  <input
    class="size-{{ size() }} {{ color() }}"
    [class.focus]="showFocus()"
    type="text"
    [placeholder]="placeholder() ?? this.I18N | translate"
    (input)="changeValue($event)"
    #searchElement
  />

  <div class="actions">
    <div class="hidden">
      @if (query()) {
        <onyx-clear-button
          data-testid="clear-button"
          (click)="clearValue()"
        ></onyx-clear-button>
      }
    </div>
  </div>

  @if (loading()) {
    <onyx-spinner color="black" [size]="16"></onyx-spinner>
  } @else {
    <onyx-icon name="search-outlined" [size]="20"></onyx-icon>
  }
</div>
